module.exports = {
  viewExports: (Api, $stateParams) ->
    query =
      project: $stateParams.projectId

    return Api.ProjectExportsDownloads.get(query).$promise

}
